import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about-page">
      <div className="about-container">
        <header className="about-header">
          <h1>ℹ️ O aplikacji codzisiaj?</h1>
          <Link to="/" className="back-link">
            ← Powrót do głównej strony
          </Link>
        </header>

        <div className="about-content">
          <section className="about-section">
            <h2>👦 Słowo od autora</h2>
            <p>
              Bardzo dziękuję Wam za tak ciepłe przyjęcie projektu! Na bieżąco dodaję zgłaszane wydarzenia
              i planuję kolejne funkcje. Póki co świętujmy dożynki — a od września pojawi się też mapa
              wydarzeń, żeby każdy mógł łatwo znaleźć coś dla siebie.
            </p>
          </section>

          <section className="about-section">
            <h2>🎯 Cel aplikacji</h2>
            <p>
              <strong>codzisiaj?</strong> to aplikacja stworzona z myślą o miłośnikach wydarzeń kulturalnych, 
              koncertów, festiwali i innych atrakcji w Polsce. Naszym celem jest ułatwienie znalezienia 
              interesujących wydarzeń w Twoim mieście lub w całym kraju.
            </p>
          </section>

          <section className="about-section">
            <h2>Funkcjonalności</h2>
            <ul>
              <li><strong>Wyszukiwanie</strong> — po dacie, artyście, mieście lub typie wydarzenia w jednym panelu</li>
              <li><strong>Zgłaszanie wydarzeń</strong> — dodaj własne wydarzenie do bazy</li>
            </ul>
          </section>

          <section className="about-section">
            <h2>🎵 Typy wydarzeń</h2>
            <div className="event-types">
              <span className="event-type-tag">🎵 Koncerty</span>
              <span className="event-type-tag">🎭 Kultura</span>
              <span className="event-type-tag">🍽️ Jedzenie</span>
              <span className="event-type-tag">🎪 Festiwale</span>
              <span className="event-type-tag">🍻 Bary</span>
              <span className="event-type-tag">⚽ Sport</span>
              <span className="event-type-tag">🔬 Nauka</span>
              <span className="event-type-tag">🎬 Kino</span>
              <span className="event-type-tag">🏪 Targi</span>
              <span className="event-type-tag">🎤 Kluby</span>
            </div>
          </section>

          <section className="about-section">
            <h2>🏙️ Miasta</h2>
            <p>
              Aplikacja obejmuje wydarzenia z największych miast Polski, w tym:
            </p>
            <div className="cities-list">
              <span className="city-tag">Warszawa</span>
              <span className="city-tag">Kraków</span>
              <span className="city-tag">Gdańsk</span>
              <span className="city-tag">Wrocław</span>
              <span className="city-tag">Poznań</span>
              <span className="city-tag">Łódź</span>
              <span className="city-tag">Katowice</span>
              <span className="city-tag">Lublin</span>
              <span className="city-tag">Białystok</span>
              <span className="city-tag">i wiele innych...</span>
            </div>
          </section>

          <section className="about-section">
            <h2>👥 Dla kogo?</h2>
            <p>
              Aplikacja jest idealna dla:
            </p>
            <ul>
              <li>Miłośników muzyki i kultury</li>
              <li>Osób szukających rozrywki na weekend</li>
              <li>Organizatorów wydarzeń</li>
              <li>Wszystkich, którzy chcą być na bieżąco z wydarzeniami w Polsce</li>
            </ul>
          </section>

          <section className="about-section">
            <h2>🚀 Jak używać?</h2>
            <ol>
              <li><strong>Wybierz datę, artystę lub miasto</strong> w panelu wyszukiwania, aby zobaczyć wydarzenia</li>
              <li>Kliknij <strong>➕</strong>, aby zgłosić własne wydarzenie</li>
            </ol>
          </section>

          <section className="about-section">
            <h2>📞 Kontakt</h2>
            <p>
              Chcesz promować swoje wydarzenie, masz pytania lub propozycje nowych funkcji? Napisz do nas:{' '}
              <a href="mailto:kontakt@codzisiaj.com">kontakt@codzisiaj.com</a>
            </p>
            <p>
              Jesteśmy też na Instagramie{' '}
              <a href="https://www.instagram.com/codzisiajcom" target="_blank" rel="noopener noreferrer">@codzisiajcom</a>
              {' '}oraz TikToku{' '}
              <a href="https://www.tiktok.com/@codzisiaj3" target="_blank" rel="noopener noreferrer">@codzisiaj3</a>.
            </p>
          </section>

          <section className="about-section">
            <h2>🔒 Prywatność</h2>
            <p>
              Informacje o przetwarzaniu danych i Google Analytics znajdziesz w{' '}
              <Link to="/polityka-prywatnosci">polityce prywatności</Link>.
            </p>
          </section>

          <section className="about-section">
            <h2>☕ Wsparcie strony</h2>
            <p>
              Jeśli podoba Ci się projekt i chcesz nas wesprzeć, możesz postawić nam kawę tutaj:
              {' '}<a href="https://buycoffee.to/codzisiaj" target="_blank" rel="noopener noreferrer">buycoffee.to/codzisiaj</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;
